var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 85,
    viewBox: "0 0 102 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#bd591d",
    transform: "matrix(-1 0 0 1 102 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 24.5,
    rx: 36,
    ry: 24.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.493 52.154l8.514-20.132 13.409 14.38L8.738 53.49a1 1 0 0 1-1.245-1.336z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(0 24)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 24.5,
    rx: 36,
    ry: 24.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.493 52.154l8.514-20.132 13.409 14.38L8.738 53.49a1 1 0 0 1-1.245-1.336z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListen);
export default __webpack_public_path__ + "static/media/listen.a91dc367428d2e1e2a21a45d80cdc034.svg";
export { ForwardRef as ReactComponent };